import Gleap from "gleap";

// Plugin: registers Gleap on `app.config.globalProperties` but does NOT
// automatically initialize the Gleap client. Initialization should be
// triggered explicitly for authorized users via `initializeGleap`.
export default {
  install(app) {
    app.config.globalProperties.$gleap = Gleap;
  },
};

export const initializeGleap = function (
  appInstance,
  token = "0iK3FAEyt9KwZu0dvaP5gnmCRzmlVzce"
) {
  if (window.__gleapInitialized) return window.Gleap || Gleap;

  try {
    if (appInstance && typeof Gleap.install === "function") {
      try {
        Gleap.install(appInstance, { token });
      } catch (e) {
        console.error("Error installing Gleap plugin:", e);
      }
    }

    // Fallback: call initialize if available.
    if (typeof Gleap.initialize === "function") {
      Gleap.initialize(token);
    }

    window.__gleapInitialized = true;
    window.Gleap = Gleap;
  } catch (err) {
    console.error("Failed to initialize Gleap:", err);
  }

  return window.Gleap || Gleap;
};

export const identifyUser = function (user, companyProfile = {}) {
  if (window.Gleap) {
    if (user.gleap_hash && user.gleap_id) {
      window.Gleap.identify(
        user.gleap_id,
        {
          name: `${user.first} ${user.last}`,
          email: user.email,
          phone: user.phone_number,
          companyId: companyProfile.name,
          companyName: companyProfile.name,
          customData: {
            role: user.isAdmin
              ? "Super Admin"
              : user.isManagingAdmin
              ? "Managing Admin"
              : user.isProvider
              ? "Provider"
              : user.isPatient
              ? "Patient"
              : "User",
            status: user.status,
          },
        },
        user.gleap_hash
      );
    }
  } else {
    console.log("Gleap not initialized");
  }
};

export const clearUserIdentity = function () {
  if (window.Gleap) {
    window.Gleap.clearIdentity();
  } else {
    console.log("Gleap not initialized");
  }
};
